module.exports = __webpack_public_path__ + "static/macos-adb956f8e0ddcdc386a8854f8764cb95.png";